var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import debounce from 'lodash/debounce';
import Api from '../model/api';
import SettingModule from '../module/setting';
import EmojiModule from '../module/emoji';
import UserModule from '../module/user';
import MsgImage from '../module/msg-image';
import I18n, * as i18nKey from '../module/i18n';
import ServerTime from '../module/server-time';
import ArrayPro from '../utils/array-pro';
import createGuid from '../utils/guid';
import Emitter from '../utils/emitter';
function templateDataIsTemp(templateData, templateId) {
    return templateId === 3;
}
function templateDataIsImage(templateData, templateId) {
    return templateId === 4;
}
var fetchCount = 50;
var SessionViewModule = (function (_super) {
    __extends(SessionViewModule, _super);
    function SessionViewModule(config, data, option) {
        var _this = _super.call(this) || this;
        _this.isConversation = false;
        _this.isInited = false;
        _this.startTime = null;
        _this.endTime = null;
        _this.config = config;
        _this.sessionId = data.sessionId;
        Object.assign(_this, data, option);
        _this._api = Api.getInstance(config);
        _this.sessionId = data.sessionId;
        _this._user = UserModule.getInstance(config);
        _this._emoji = EmojiModule.getInstance(config);
        _this._msgImg = MsgImage.getInstance(config);
        _this._i18n = I18n.getInstance(config);
        _this._stime = new ServerTime(config);
        _this._setting = new SettingModule(config, {
            type: 1,
        });
        _this._msgList = new ArrayPro({ order: 'sendTime' });
        _this.debounceSaveDb = debounce(function (debounceFn) {
            if (debounceFn) {
                debounceFn();
            }
            _this.emit('message_update');
        }, config.delayTime);
        _this.debounceEmitMsg = debounce(function (newMsgList) {
            _this.emit('read_new_message', newMsgList);
        }, config.delayTime);
        return _this;
    }
    SessionViewModule.prototype.init = function (startTime) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.isInited) {
                            return [2, Promise.resolve()];
                        }
                        return [4, this._queryMessageData(startTime || -1)];
                    case 1:
                        _a.sent();
                        this.isInited = true;
                        this.debounceSaveDb();
                        return [2];
                }
            });
        });
    };
    SessionViewModule.prototype.getSettingList = function () {
        return this._setting.get();
    };
    SessionViewModule.prototype.getMessageList = function () {
        return this._msgList.getAll();
    };
    SessionViewModule.prototype.getMoreMessage = function (isDownward) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!isDownward) return [3, 2];
                        return [4, this._queryMessageData(this.endTime || -1, isDownward)];
                    case 1:
                        _a.sent();
                        return [3, 4];
                    case 2: return [4, this._queryMessageData(this.startTime || -1, isDownward)];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4:
                        this.debounceSaveDb();
                        return [2, this.getMessageList()];
                }
            });
        });
    };
    SessionViewModule.prototype._queryMessageData = function (startTime, isDownward) {
        return __awaiter(this, void 0, void 0, function () {
            var config, param, result, allPromise;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        config = this.config;
                        param = {
                            accessKey: config.accessKey,
                            accessToken: config.accessToken,
                            accountType: config.accountType,
                            sessionViewId: this.sessionId,
                            fetchCount: fetchCount,
                            startTime: startTime,
                            isDownward: isDownward,
                        };
                        return [4, this._api.request(config._url.queryNodeListBySessionId, param).catch(function (err) {
                                return {};
                            })];
                    case 1:
                        result = _a.sent();
                        result = result.result || result;
                        allPromise = [];
                        if (Array.isArray(result)) {
                            allPromise = result === null || result === void 0 ? void 0 : result.map(function (message) { return __awaiter(_this, void 0, void 0, function () {
                                var messageData, sendTime;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4, this.getParseMessage(message)];
                                        case 1:
                                            messageData = _a.sent();
                                            if (messageData) {
                                                this._msgList.set(messageData.messageId, messageData);
                                                sendTime = parseInt(messageData.sendTime);
                                                if (!this.startTime || sendTime < this.startTime) {
                                                    this.startTime = sendTime;
                                                }
                                                if (!this.endTime || sendTime > this.endTime) {
                                                    this.endTime = sendTime;
                                                }
                                            }
                                            return [2];
                                    }
                                });
                            }); });
                        }
                        return [2, Promise.all(allPromise)];
                }
            });
        });
    };
    SessionViewModule.prototype.getParseMessage = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, config, _b, body, _c, typeData, _d, layoutData, _e, ext, user, templateData, processResult, i18n, formatI18nMap, selectedI18n, parsedTemplateData, sendTime, templateType, readStatus;
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        _a = this.config, config = _a === void 0 ? {} : _a;
                        _b = data.body, body = _b === void 0 ? {} : _b;
                        _c = body.typeData, typeData = _c === void 0 ? {} : _c, _d = body.layoutData, layoutData = _d === void 0 ? {} : _d;
                        _e = typeData.ext, ext = _e === void 0 ? {} : _e;
                        user = this._user.getUserData(typeData.fromType, typeData.from);
                        templateData = body.templateData || '';
                        try {
                            templateData = JSON.parse(templateData);
                            processResult = ext.processResult;
                            if (processResult && typeof processResult === 'string' && processResult.length) {
                                ext.processResult = JSON.parse(processResult);
                            }
                        }
                        catch (e) {
                            console.log(e);
                            return [2, Promise.resolve(null)];
                        }
                        i18n = ext.i18n;
                        if (i18n) {
                            try {
                                formatI18nMap = JSON.parse(i18n);
                                selectedI18n = formatI18nMap[config.lang];
                                if (selectedI18n) {
                                    templateData = JSON.parse(selectedI18n);
                                }
                            }
                            catch (e) {
                                console.log(e);
                            }
                        }
                        return [4, this.parseTemplateInfo(typeData.tempId, templateData, body.templateInfo)];
                    case 1:
                        parsedTemplateData = _f.sent();
                        if (!parsedTemplateData) {
                            return [2, null];
                        }
                        sendTime = parseInt(typeData.sendTime);
                        templateType = parseInt(typeData.tempId);
                        if (templateType === 2 && parseInt(sendTime) === sendTime || ext.mf === 'auto') {
                            sendTime += 0.5;
                        }
                        readStatus = this.toPosition >= sendTime ? 1 : 0;
                        return [2, {
                                messageId: typeData.mid,
                                user: user,
                                sendTime: sendTime,
                                status: parseInt((typeData.status || 0)),
                                readStatus: readStatus,
                                templateType: parseInt(typeData.tempId),
                                cardType: parseInt(layoutData.card),
                                templateData: parsedTemplateData,
                                processResult: ext.processResult,
                                ext: ext,
                            }];
                }
            });
        });
    };
    SessionViewModule.prototype.parseTemplateInfo = function (templateType, dataObj, infoStr) {
        return __awaiter(this, void 0, void 0, function () {
            var defaultTemplateMap, _a, emojiData;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        defaultTemplateMap = this.config.messageTemplateInfo[templateType] || {};
                        if (!infoStr && defaultTemplateMap.templateInfo) {
                            infoStr = defaultTemplateMap.templateInfo;
                        }
                        templateType = parseInt(templateType);
                        if (!(templateDataIsTemp(dataObj, templateType) && dataObj.osskey && !dataObj.imgUrl)) return [3, 2];
                        _a = dataObj;
                        return [4, this._msgImg.getDownloadToken(dataObj.osskey)];
                    case 1:
                        _a.imgUrl = _b.sent();
                        return [2, Promise.resolve(dataObj)];
                    case 2:
                        if (templateDataIsImage(dataObj, templateType)) {
                            emojiData = this._emoji.getByKey(dataObj.txt);
                            if (emojiData) {
                                dataObj.imgUrl = emojiData.imgUrl;
                            }
                        }
                        _b.label = 3;
                    case 3: return [2, Promise.resolve(dataObj)];
                }
            });
        });
    };
    SessionViewModule.prototype.sendMockImage = function (templateData, msgId) {
        var _a = this, config = _a.config, _user = _a._user;
        var templateId = 3;
        var tempMessageData = {
            messageId: msgId,
            user: _user.getUserData(config.accountType, config.userId),
            sendTime: this._stime.getTime(),
            status: 11,
            readStatus: 0,
            templateType: templateId,
            cardType: config.messageTemplateInfo[templateId].cardType,
            templateData: templateData,
            processResult: null,
        };
        this.updateMsgData(tempMessageData, true);
        return Promise.resolve(tempMessageData);
    };
    SessionViewModule.prototype.sendAndUpdateImage = function (param, imgData, templateData, msgId) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, config, _user, _msgList, templateId, tempMessageData, data, err_1;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this, config = _a.config, _user = _a._user, _msgList = _a._msgList;
                        templateId = 3;
                        tempMessageData = {
                            messageId: msgId,
                            user: _user.getUserData(config.accountType, config.userId),
                            sendTime: this._stime.getTime(),
                            status: 11,
                            readStatus: 0,
                            templateType: templateId,
                            cardType: config.messageTemplateInfo[templateId].cardType,
                            templateData: templateData,
                            processResult: null,
                        };
                        templateData.imgUrl = imgData.imgUrl;
                        templateData.osskey = imgData.osskey;
                        param.content = JSON.stringify(templateData);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4, this._api.request(config._url.sendMessage, param, {
                                type: 'post',
                                dataType: 'json',
                            }).catch(function (err) {
                                return {};
                            })];
                    case 2:
                        data = _b.sent();
                        _msgList.remove(msgId);
                        tempMessageData.messageId = data.messageId;
                        tempMessageData.sendTime = Number(data.currentTime);
                        tempMessageData.status = 0;
                        this.parseTemplateInfo(templateId, templateData).then(function (templateData) {
                            tempMessageData.templateData = templateData;
                            _this.updateMsgData(tempMessageData);
                        });
                        return [2, tempMessageData];
                    case 3:
                        err_1 = _b.sent();
                        tempMessageData.status = 13;
                        this.parseTemplateInfo(templateId, templateData).then(function (templateData) {
                            tempMessageData.templateData = templateData;
                            _this.updateMsgData(tempMessageData);
                        });
                        throw err_1;
                    case 4: return [2];
                }
            });
        });
    };
    SessionViewModule.prototype.sendMessage = function (templateId, templateData, msgId, ext) {
        var _this = this;
        if (ext === void 0) { ext = {}; }
        var _a = this, config = _a.config, _user = _a._user, _msgList = _a._msgList, _i18n = _a._i18n;
        var isRetry = false;
        templateId = parseInt(templateId);
        if (typeof templateData === 'string' && (templateId === 1 || templateId === 4)) {
            templateData = { txt: templateData };
        }
        templateData = templateData;
        if (msgId && _msgList.get(msgId)) {
            _msgList.remove(msgId);
            isRetry = true;
        }
        else if (!msgId) {
            msgId = createGuid();
        }
        var content = JSON.stringify(templateData);
        if (content.length > 2048) {
            return Promise.reject({ type: 'CONTENT_TOO_LONG', message: _i18n.getTxt(i18nKey.CONTENT_TOO_LONG) });
        }
        var extValue = '';
        try {
            ext.fromCode = this.fromCode;
            extValue = JSON.stringify(ext);
        }
        catch (e) {
            extValue = JSON.stringify({ fromCode: this.fromCode });
        }
        var param = {
            accessKey: config.accessKey,
            accessToken: config.accessToken,
            umidToken: typeof config.umidToken === 'function' ? config.umidToken() : config.umidToken,
            sessionId: this.sessionId,
            content: content,
            templateId: templateId,
            fromAppKey: config.accsAppKey,
            bizUnique: msgId,
            ext: extValue,
        };
        if (templateDataIsTemp(templateData, templateId)) {
            if (templateData.imgUrl.startsWith('blob:')) {
                var image = templateData.image, uploadImage = templateData.uploadImage;
                if (image && uploadImage) {
                    uploadImage([image]).then(function (imgData) {
                        _this.sendAndUpdateImage(param, imgData, templateData, msgId);
                    });
                    return this.sendMockImage(templateData, msgId);
                }
            }
        }
        if (templateDataIsImage(templateData, templateId)) {
            var emojiData = this._emoji.getByKey(templateData.txt) || {};
            templateData.imgUrl = emojiData.imgUrl;
        }
        var tempMessageData = {
            messageId: msgId,
            user: _user.getUserData(config.accountType, config.userId),
            sendTime: this._stime.getTime(),
            status: (isRetry ? 12 : 11),
            readStatus: 0,
            templateType: templateId,
            cardType: config.messageTemplateInfo[templateId].cardType,
            templateData: templateData,
            processResult: null,
        };
        var parseInfoPromise = this.parseTemplateInfo(templateId, templateData).then(function (templateData) {
            tempMessageData.templateData = templateData;
            _this.updateMsgData(tempMessageData, true);
        });
        return this._api.request(config._url.sendMessage, param, {
            type: 'post',
            dataType: 'json',
        }).then(function (data) {
            _msgList.remove(msgId);
            tempMessageData.messageId = data.messageId;
            tempMessageData.sendTime = Number(data.currentTime);
            tempMessageData.status = 0;
            parseInfoPromise.then(function () {
                _this.updateMsgData(tempMessageData);
            });
            return tempMessageData;
        }).catch(function (err) {
            tempMessageData.status = 13;
            parseInfoPromise.then(function () {
                _this.updateMsgData(tempMessageData);
            });
            return Promise.reject(err);
        });
    };
    SessionViewModule.prototype.updateMsgData = function (msgData, isMock) {
        this._msgList.set(msgData.messageId, msgData);
        if (msgData.status === 1) {
            this.emit("message_withdraw", msgData.messageId);
        }
        if (isMock) {
            this.content = this.createSummary(msgData);
            this.lastMessageTime = msgData.sendTime;
            this.emit('message_update');
        }
        else if (this.isConversation) {
            this.checkAndEmitNewMessage();
            this.setAllRead(1);
        }
        else if (!this.isInited && this.config.userId !== msgData.user.userId) {
            if (this.isInited && msgData.sendTime > this.selfPosition) {
                this.nonReadNumber += 1;
            }
            this.debounceSaveDb();
        }
    };
    SessionViewModule.prototype.createSummary = function (msgData) {
        var _a = this, _i18n = _a._i18n, _emoji = _a._emoji;
        var summary = msgData.templateData.txt;
        var templateType = parseInt(msgData.templateType);
        if (templateType === 3) {
            summary = _i18n.getTxt(i18nKey.IM_PUSHTEXT_IMAGE);
        }
        else if (templateType === 4) {
            var emojiData = _emoji.getByKey(summary);
            if (emojiData) {
                summary = "[" + emojiData.name + "]";
            }
        }
        else if (templateType === 10006) {
            summary = _i18n.getTxt(i18nKey.IM_PUSHTEXT_PRODUCTCARD);
        }
        else if (templateType === 10007) {
            summary = _i18n.getTxt(i18nKey.IM_PUSHTEXT_ORDERCARD);
        }
        else if (templateType === 10008) {
            summary = _i18n.getTxt(i18nKey.IM_PUSHTEXT_COLLECTIVE_VOUCHER_CARD);
        }
        else if (templateType === 10009) {
            summary = _i18n.getTxt(i18nKey.IM_PUSHTEXT_ORDERCARD);
        }
        else if (templateType === 10010) {
            summary = _i18n.getTxt(i18nKey.IM_PUSHTEXT_FOLLOWCARD);
        }
        return summary;
    };
    SessionViewModule.prototype.updateToReadStatus = function (toPosition) {
        var _this = this;
        var msgList = this.getMessageList();
        var _loop_1 = function (i) {
            var msgData = msgList[i];
            if (msgData.readStatus)
                return "break";
            msgData.readStatus = toPosition >= msgData.sendTime ? 1 : 0;
            Promise.resolve().then(function () {
                _this._msgList.set(msgData.messageId, msgData);
            });
        };
        for (var i = msgList.length - 1; i >= 0; i--) {
            var state_1 = _loop_1(i);
            if (state_1 === "break")
                break;
        }
        this.debounceSaveDb();
    };
    SessionViewModule.prototype.getNonReadNum = function () {
        var nonReadNumber = 0;
        if (this.isConversation) {
            return nonReadNumber;
        }
        if (!this.isInited) {
            return this.nonReadNumber;
        }
        var msgList = this.getMessageList();
        var index = msgList.length - 1;
        for (; index > 0; index--) {
            var msgData = msgList[index];
            var isSelfMsg = this.config.userId === msgData.user.userId;
            if (!isSelfMsg) {
                if (this.selfPosition >= msgData.sendTime)
                    break;
                nonReadNumber++;
            }
        }
        this.nonReadNumber = nonReadNumber;
        return nonReadNumber;
    };
    SessionViewModule.prototype.getLastSendTime = function (msgList) {
        this.nonReadNumber = 0;
        var time = 0;
        for (var index = msgList.length - 1; index >= 0; index--) {
            var msgData = msgList[index];
            if (this.config.userId !== msgData.user.userId) {
                time = msgData.sendTime;
                break;
            }
        }
        time = time || this._stime.getTime();
        return time;
    };
    SessionViewModule.prototype.hasNewMessage = function () {
        var msgList = this.getMessageList();
        if (msgList.length === 0) {
            return false;
        }
        var lastMessage = msgList[msgList.length - 1];
        return lastMessage.sendTime > this.selfPosition
            && lastMessage.user.userId !== this.config.userId;
    };
    SessionViewModule.prototype.getNewMessages = function () {
        var _this = this;
        var msgList = this.getMessageList();
        return msgList.filter(function (msg) {
            return msg.sendTime > _this.selfPosition
                && msg.user.userId !== _this.config.userId;
        });
    };
    SessionViewModule.prototype.checkAndEmitNewMessage = function () {
        if (this.hasNewMessage()) {
            this.debounceEmitMsg(this.getNewMessages());
        }
    };
    SessionViewModule.prototype.setAllRead = function (nonReadNumber, isSetConversion) {
        var msgList = this.getMessageList();
        if (nonReadNumber < 1) {
            return;
        }
        var time = this.getLastSendTime(msgList);
        this.putReadOffset(time, isSetConversion);
        this.debounceSaveDb();
    };
    SessionViewModule.prototype.putReadOffset = function (time, isSetConversion) {
        if (time < this.selfPosition && !isSetConversion) {
            return;
        }
        var _a = this, config = _a.config, toUser = _a.toUser;
        this.selfPosition = time;
        var param = {
            accessKey: config.accessKey,
            accessToken: config.accessToken,
            sessionId: this.sessionId,
            timestamp: parseInt(time),
            ext: JSON.stringify({
                toUserType: String(toUser.userType),
                toUserId: String(toUser.userId),
            }),
        };
        this._api.request(config._url.putRangeReadOffset, param).catch(function (err) {
            return {};
        });
    };
    SessionViewModule.prototype.messageWithdraw = function (messageId) {
        return __awaiter(this, void 0, void 0, function () {
            var config, param;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        config = this.config;
                        param = {
                            accessKey: config.accessKey,
                            accessToken: config.accessToken,
                            accountType: config.accountType,
                            sessionViewId: this.sessionId,
                            messageId: messageId
                        };
                        return [4, this._api.request(config._url.messageRecall, param).catch(function (err) {
                                return {};
                            })];
                    case 1:
                        _a.sent();
                        return [2];
                }
            });
        });
    };
    SessionViewModule.prototype.messageSound = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, config, isConversation, _b, isRingtoneEnabled, error_1;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _a = this, config = _a.config, isConversation = _a.isConversation;
                        _b = config.isRingtoneEnabled, isRingtoneEnabled = _b === void 0 ? false : _b;
                        if (!(!isConversation && isRingtoneEnabled)) return [3, 4];
                        if (!this.ringtoneAudio) {
                            this.ringtoneAudio = document.createElement('audio');
                            this.ringtoneAudio.src = 'https://g.alicdn.com/lazada/static/1.0.4/music/ae-im.mp3';
                        }
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 3, , 4]);
                        return [4, this.ringtoneAudio.play()];
                    case 2:
                        _c.sent();
                        return [3, 4];
                    case 3:
                        error_1 = _c.sent();
                        console.log(error_1);
                        return [3, 4];
                    case 4: return [2];
                }
            });
        });
    };
    return SessionViewModule;
}(Emitter));
export default SessionViewModule;
